import React from 'react';
import RequireAuth from './features/auth/requireAuth';
import RequireAdmin from './features/auth/requireAdmin';
import { Routes, Route} from "react-router-dom";
import { ThemeProvider } from '@emotion/react';
import { Container, CssBaseline } from '@mui/material';
import GetTheme from "./helpers/theme";

import Home from './pages/Home';
import Login from './features/auth/login';
import ProductFamilyBrowser from './pages/ProductFamilyBrowser';
import Layout from './components/layout.js';

import './App.css';
import Footer from './components/Footer';
import Header from './components/Header';
import ProductsBrowser from './pages/ProductsBrowser';
import ProductView from './pages/ProductView';
import ProductEditView from './pages/ProductEditView';
import DesignCategoriesBrowser from './pages/DesignCategoriesBrowser';
import DesignsBrowser from './pages/DesignsBrowser';
import DesignView from './pages/DesignView';
import SalesRepsBrowser from './pages/salesrep/SalesRepsBrowser';
import SalesRepView from './pages/salesrep/SalesRepView';
import { OrderView } from './pages/OrderView';
import { OrdersBrowser } from './pages/OrdersBrowser';
import PersonsBrowser from './pages/people/PersonsBrowser';
import PersonView from './pages/people/PersonView';
import FinderRegistrationView from './pages/finder/FinderRegistrationView';
import CommissionsView from './pages/salesrep/CommissionsView';
import FinderView from './pages/finder/FinderView';
import PasswordResetView from './pages/PasswordResetView';
import { OrderEditView } from './pages/OrderEditView';
import DistributorRegistrationView from './pages/distributor/DistributorRegistrationView.js';
import ToolProfileBrowser from './pages/ToolProfileBrowser.js'
import ToolProfileView from './pages/ToolProfileView.js';
import ToolProfileEditView from './pages/ToolProfileEditView.js';
import DistributorView from './pages/distributor/DistributorView.js';
import PurchaseOrderForm from './pages/po/PurchaseOrderForm.js';
import { PurchaseOrderEditView } from './pages/po/PurchaseOrderEditView.js';
import PurchaseOrderSwitcher from './pages/po/PurchaseOrderSwitcher.js';
import CustomItemsBrowser from './pages/CustomItemsView.js';
import { CustomItemView } from './pages/CustomItemView.js';
import CustomItemEditView from './pages/CustomItemEditView.js';
import { AllPermissionsView } from './pages/people/PermissionsView.js';
import { ShippingSettingsView } from './pages/ShippingSettingsView.js';
import { OverdueOrdersReport } from './pages/Reports.js';

function App() {
  return <ThemeProvider theme={GetTheme()}>
    <CssBaseline />
    <Header />
    <Container maxWidth={false}>
    <Routes>
      <Route path={"/"} element={<Layout />} />
      <Route path={"/finders"} element={<FinderView />}/>
      <Route path={"/finders/register/"} element={<FinderRegistrationView />} />
      <Route path={"/distributor"} element={<DistributorView />} />
      <Route path={"/distributor/register/"} element={<DistributorRegistrationView />} />
      <Route path={"/purchaseorder"} element={<PurchaseOrderSwitcher />} />
      <Route element={<RequireAuth />}>
        <Route index element={<Home />} />
        <Route path={"/orders/"} element={<OrdersBrowser />} />
        <Route path={"/orders/:orderId"} element={<OrderView />} />
        <Route path={"/orders/:orderId/edit"} element={<OrderEditView />} />
        <Route path={"/orders/:orderId/po"} element={<PurchaseOrderEditView />} />
        <Route path={"/reports/orders"} element={<OverdueOrdersReport />} />
        <Route path={"/designs/"} element={<DesignCategoriesBrowser />} />
        <Route path={"/designs/:categoryId"} element={<DesignsBrowser />} />
        <Route path={"/designs/:categoryId/:designId"} element={<DesignView />} />
        <Route path={"/products/"} element={<ProductFamilyBrowser />} />
        <Route path={"/products/:familyId"} element={<ProductsBrowser />} />
        <Route path={"/products/:familyId/:productId"} element={<ProductView />} />
        <Route path={"/products/:familyId/:productId/edit"} element={<ProductEditView />} />
        <Route path={"/salesreps/"} element={<SalesRepsBrowser />} />
        <Route path={"/salesreps/:objectId"} element={<SalesRepView />} />
        <Route path={"/commissions/"} element={<CommissionsView />} />
        <Route path={"/toolprofiles/"} element={<ToolProfileBrowser />} />
        <Route path={"/toolprofiles/:objectId"} element={<ToolProfileView />} />
        <Route path={"/toolprofiles/:objectId/Edit"} element={<ToolProfileEditView />} />
        <Route path={"/customitems/"} element={<CustomItemsBrowser />} />
        <Route path={"/customitems/:objectId"} element={<CustomItemView />} />
        <Route path={"/customitems/:objectId/Edit"} element={<CustomItemEditView />} />
        <Route element={<RequireAdmin />}>
          <Route path={`/persons/`} element={<PersonsBrowser />} />
          <Route path={`/persons/:objectId`} element={<PersonView />} />
          <Route path={`/permissions/`} element={<AllPermissionsView />} />
          <Route path={`/shippingsettings/`} element={<ShippingSettingsView />} />
        </Route>
      </Route>
      <Route path={"/login"} element={<Login />} />
      <Route path={"/passwordreset"} element={<PasswordResetView />} />
    </Routes>
    </Container>
    <Footer />
    </ThemeProvider>
}

export default App;
